import React from "react";
import TrackedButton from "../../Docuclipper/TrackedButton";
import { useDispatch } from "react-redux";

import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { reportBadExtraction } from "../../../redux/reducers/TemplateField";
import {
  Fragment,
  TemplateFieldV2,
} from "../../../docuclipper/DocuclipperTypes";
import { withSelectedFragment } from "./v2/withSelectedFragment";
import { withSelectedField } from "./v2/withSelectedField";

type Props = {
  fragment: Fragment;
  field: TemplateFieldV2;
};

export const FlagBadExtractionButton2: React.SFC<Props> = ({
  fragment,
  field,
}) => {
  const dispatch = useDispatch();
  const reported = fragment.rating === "bad";

  const flagBadDataExtraction = () => {
    dispatch(reportBadExtraction({ fragmentId: fragment.id, id: field.id }));
  };
  return (
    <>
      {reported ? (
        <>
          <span className="mr-1">Reported</span>
          <FontAwesomeIcon color="green" icon="check" />
        </>
      ) : (
        <>
          <OverlayTrigger
            popperConfig={{
              modifiers: {
                preventOverflow: {
                  enabled: false,
                },
              } as any,
            }}
            placement="top"
            overlay={
              <Tooltip id="reportIncorrectDataExtraction">
                Report incorrect data extraction
              </Tooltip>
            }
          >
            <TrackedButton
              className="btn--flag-data-extraction"
              variant="link"
              action="flagBadExtractionClick"
              onClick={() => flagBadDataExtraction()}
            >
              <FontAwesomeIcon color="red" icon="exclamation-triangle" />
            </TrackedButton>
          </OverlayTrigger>
        </>
      )}
    </>
  );
};

export const FlagBadExtractionButton = withSelectedField(
  withSelectedFragment(FlagBadExtractionButton2)
);
